// extracted by mini-css-extract-plugin
module.exports = {"textInput":"InputComponent_textInput___dfsQ"};